export default "__VITE_ASSET__462ee2f8__"